import { Container, styled } from '@mui/material'

export const StyledLangSocialLinksContainer = styled(Container)(() => ({
  marginTop: 42,
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
}))
